export default [
	{
		modulo: 5,
		privilegio: 57,
		routerName: 'registro-voo',
		routerPath: '/hfdm',
		componentName: 'HFDM',
		componentPath: 'modules/layout/hfdm/main'
	},
	{
		modulo: 5,
		privilegio: 57,
		props: true,
		routerName: 'registro-voo-dinamico',
		routerPath: '/hfdm/:id',
		componentName: 'HFDM',
		componentPath: 'modules/layout/hfdm/main'
	}
]
